// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI);

// 引入公用样式
import '@/assets/css/index.css'
import '@/assets/css/style.css'

import '@/assets/js/jquery-1.9.1.min.js';
import '@/assets/js/mobile.js';
import '@/assets/js/common.js';

import api from'./utils/api.js';//接口方法名称
import json from'./utils/json.js';//数据
import utils from './utils/utils.js';//工具方法

import Request from './utils/request' // 引入封装的文件 - 请求接口方法
const { request, baseURL } = Request;
Vue.prototype.$http = request;
Vue.prototype.baseURL = baseURL;

Vue.prototype.api = api;
Vue.prototype.json = json;
Vue.prototype.utils = utils;

Vue.config.productionTip = false

import scroll from 'vue-seamless-scroll'
Vue.use(scroll)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js